<ng-container *ngIf="{ currentPageData: currentPageData | async } as content">
  <span *ngIf="content.currentPageData?.pagination">
    {{
      getDisplayValue(content.currentPageData?.pagination?.totalResults ?? 0, content.currentPageData?.pagination?.pageSize ?? 0).display
    }}
    of
    {{ getDisplayValue(content.currentPageData?.pagination?.totalResults ?? 0, content.currentPageData?.pagination?.pageSize ?? 0).total }}
  </span>
</ng-container>
